<template>
  <div>
    <div class="field" :class="[item.layout]" :style="formItemStyle">
      <div class="name" v-if="item.name">
        <span class="flag" v-if="item.required">*</span>
        <span class="b-title">{{item.name}}</span>
        <slot name="extra"></slot>
        <span class="warn" v-if="warning.valid===false">{{warning.message||''}}</span>
      </div>
      <slot name="extra2"></slot>
      <div
      class="input-wrapper"
      :class="{'focus-ui': focused||warning.valid===false, 'noborder': !haveBorder, 'tgo-textarea': formItemStyle === 'textarea', 'iview': iview}">
        <slot name="input"></slot>
        <slot name="input-extra"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import check from './check'

export default {
  data () {
    return {
      warning: {},
      warns: {},
      focused: false
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return { name: '', required: false }
      }
    },
    haveBorder: {
      type: Boolean,
      default: true
    },
    'form-item-style': {
      type: String
    },
    iview: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    blurFn (item, info) {
      this.focused = false
      if (item.regName) {
        if (item.key === 'focus_areas_tags' && Array.isArray(info[item.key]['1'])) {
          this.warning = check[item.regName](info[item.key]['1'] + '', item.warnTag || '')
        } else {
          this.warning = check[item.regName](info[item.key] + '', item.warnTag || '')
        }
        if (item.required) {
          this.$emit('setOKList', { 'warning': this.warning, 'key': item.key })
        }
      }
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.field
  margin-bottom: 18px
  .name
    margin-bottom: 8px
    display: flex
    align-items: center
    transition: all 1s linear
    .b-title
      margin-right: 15px
      word-break: keep-all
    .flag
      color: $primary3
      font-size: 24px
      margin-right: 5px
    .warn
      font-size: 14px
      color: $primary3
  .input-wrapper
    margin-left: 48px
    padding: 4px 12px
    border: 1px solid #ccc
    border-radius: 3px
    transition: all .3s
    +mobile
      margin-left: 0
    &:hover
      border-color: $primary3
    &.iview
      padding: 0px
    &.tgo-textarea
      padding: 8px
    &.focus-ui
      box-shadow: inset 0 1px 6px rgba(255, 90, 5, 0.1)
      border-color: $primary3
      &.noborder
        border: none
        box-shadow: none
    &.noborder
      border: none
    .text-input
      display: inline-block
      width: 100%
      height: 28px
      outline: none
      border: none
      background-color: transparent
      font-size: 14px
      -webkit-appearance: textfield

.compaction
  display: flex
  align-items: center
  .name
    margin: 0
    .b-title
    .flag
    .warn
  .input-wrapper
    margin-left: 0
    // width: 100%
    flex-grow: 1
    &.textarea
      padding: 8px
      width: auto
    &.focus-ui
      box-shadow: inset 0 1px 6px rgba(255, 90, 5, 0.1)
      border-color: $primary3
      &.noborder
        border: none
        box-shadow: none
    &.noborder
      border: none
    .text-input
      display: inline-block
      width: 100%
      height: 28px
      outline: none
      border: none
      background-color: transparent
      font-size: 14px
      -webkit-appearance: textfield

</style>
